// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://bscscan.com/address/0x657b128a4936542A48a40C320BFfa3F44043583a
export const SolvBTC_Proof_of_Reserves = '0x657b128a4936542A48a40C320BFfa3F44043583a';

// https://bscscan.com/address/0xC333eb0086309a16aa7c8308DfD32c8BBA0a2592
export const DOT__USD = '0xC333eb0086309a16aa7c8308DfD32c8BBA0a2592';

// https://bscscan.com/address/0xF4C5e535756D11994fCBB12Ba8adD0192D9b88be
export const TRX__USD = '0xF4C5e535756D11994fCBB12Ba8adD0192D9b88be';

// https://bscscan.com/address/0x22Db8397a6E77E41471dE256a7803829fDC8bC57
export const JPY__USD = '0x22Db8397a6E77E41471dE256a7803829fDC8bC57';

// https://bscscan.com/address/0x7B49524ee5740c99435f52d731dFC94082fE61Ab
export const AXS__USD = '0x7B49524ee5740c99435f52d731dFC94082fE61Ab';

// https://bscscan.com/address/0x921Fa3C67286385b22dE244e51E5925D98B03130
export const uniBTC__BTC_Exchange_Rate = '0x921Fa3C67286385b22dE244e51E5925D98B03130';

// https://bscscan.com/address/0xeF0a3109ce97e0B58557F0e3Ba95eA16Bfa4A89d
export const INR__USD = '0xeF0a3109ce97e0B58557F0e3Ba95eA16Bfa4A89d';

// https://bscscan.com/address/0x4e5a43A79f53c0a8e83489648Ea7e429278f8b2D
export const LTC__BNB = '0x4e5a43A79f53c0a8e83489648Ea7e429278f8b2D';

// https://bscscan.com/address/0x8ECF7dE377F788A813F5215668E282556b35f300
export const SVR_BTC__USD = '0x8ECF7dE377F788A813F5215668E282556b35f300';

// https://bscscan.com/address/0x14Aed7178df8d33755b1c4b8f3CC3e0EAa2B203B
export const SVR_BTC__USD_BASE = '0x14Aed7178df8d33755b1c4b8f3CC3e0EAa2B203B';

// https://bscscan.com/address/0xedE67e8dda821090e019Be754A7F61b4129FbF17
export const USDf__USD = '0xedE67e8dda821090e019Be754A7F61b4129FbF17';

// https://bscscan.com/address/0xEC5BF47f443d92b1BedF9058A472d91461e4F9b3
export const enzoBTC_Proof_of_Reserves = '0xEC5BF47f443d92b1BedF9058A472d91461e4F9b3';

// https://bscscan.com/address/0xE5dbFD9003bFf9dF5feB2f4F445Ca00fb121fb83
export const FIL__USD = '0xE5dbFD9003bFf9dF5feB2f4F445Ca00fb121fb83';

// https://bscscan.com/address/0x14Ae6B76cd940Fa449381cdC9f3a098A3D39A730
export const savBTC__avBTC_Exchange_Rate = '0x14Ae6B76cd940Fa449381cdC9f3a098A3D39A730';

// https://bscscan.com/address/0xf7E7c0ffCB11dAC6eCA1434C67faB9aE000e10a7
export const WING__USD = '0xf7E7c0ffCB11dAC6eCA1434C67faB9aE000e10a7';

// https://bscscan.com/address/0x1a269eA1b209DA2c12bDCDab22635C9e6C5028B2
export const SUSDE__USDE_Exchange_Rate = '0x1a269eA1b209DA2c12bDCDab22635C9e6C5028B2';

// https://bscscan.com/address/0x04C584Ce3EF042f32818ecFEEDC625A353a0960A
export const SVR_XVS__USD = '0x04C584Ce3EF042f32818ecFEEDC625A353a0960A';

// https://bscscan.com/address/0x553a88F6887Bc69d4d8bF07dfcbcE1Bbe442a79a
export const SVR_XVS__USD_BASE = '0x553a88F6887Bc69d4d8bF07dfcbcE1Bbe442a79a';

// https://bscscan.com/address/0x2d1AB79D059e21aE519d88F978cAF39d74E31AEB
export const COIN__USD = '0x2d1AB79D059e21aE519d88F978cAF39d74E31AEB';

// https://bscscan.com/address/0x83B8DF906c631dD7460Ac875Dc02A62db1dcD37A
export const YUSD_USD_Exchange_Rate = '0x83B8DF906c631dD7460Ac875Dc02A62db1dcD37A';

// https://bscscan.com/address/0x97E87D0c607Ca16E90073D723FEAd83d3882F4b7
export const SVR_UNI__USD = '0x97E87D0c607Ca16E90073D723FEAd83d3882F4b7';

// https://bscscan.com/address/0xdaE1A1213F01aA158388BB4a37091FCa05D692d6
export const SVR_UNI__USD_BASE = '0xdaE1A1213F01aA158388BB4a37091FCa05D692d6';

// https://bscscan.com/address/0x2e1C3b6Fcae47b20Dd343D9354F7B1140a1E6B27
export const CRV__USD = '0x2e1C3b6Fcae47b20Dd343D9354F7B1140a1E6B27';

// https://bscscan.com/address/0x87Ea38c9F24264Ec1Fff41B04ec94a97Caf99941
export const BUSD__BNB = '0x87Ea38c9F24264Ec1Fff41B04ec94a97Caf99941';

// https://bscscan.com/address/0x25298F020c3CA1392da76Eb7Ac844813b218ccf7
export const UNI__BNB = '0x25298F020c3CA1392da76Eb7Ac844813b218ccf7';

// https://bscscan.com/address/0x428f1d3A31E2b648791b875c70A9Ab1aFda4d331
export const SVR_SOL__USD = '0x428f1d3A31E2b648791b875c70A9Ab1aFda4d331';

// https://bscscan.com/address/0xCE3ed5b9AF3a0686EEa8c42dED1D62371d47597e
export const SVR_SOL__USD_BASE = '0xCE3ed5b9AF3a0686EEa8c42dED1D62371d47597e';

// https://bscscan.com/address/0xf93b9B23c46331704EC550c24CB4110975057863
export const solvBTC__BTC = '0xf93b9B23c46331704EC550c24CB4110975057863';

// https://bscscan.com/address/0xD7eAa5Bf3013A96e3d515c055Dbd98DbdC8c620D
export const YFI__USD = '0xD7eAa5Bf3013A96e3d515c055Dbd98DbdC8c620D';

// https://bscscan.com/address/0x3AB0A0d137D4F946fBB19eecc6e92E64660231C8
export const DOGE__USD = '0x3AB0A0d137D4F946fBB19eecc6e92E64660231C8';

// https://bscscan.com/address/0x41A292Dced910690b86b99A6cbC2e181dc56De57
export const LBTC__BTC = '0x41A292Dced910690b86b99A6cbC2e181dc56De57';

// https://bscscan.com/address/0xF884002406Ac6Fd93FF5C989506220f781A97eEA
export const SVR_DOGE__USD = '0xF884002406Ac6Fd93FF5C989506220f781A97eEA';

// https://bscscan.com/address/0x1281B737f47076DD70a277775E3c17a5e44dcf87
export const SVR_DOGE__USD_BASE = '0x1281B737f47076DD70a277775E3c17a5e44dcf87';

// https://bscscan.com/address/0x9a177Bb9f5b6083E962f9e62bD21d4b5660Aeb03
export const _1INCH__USD = '0x9a177Bb9f5b6083E962f9e62bD21d4b5660Aeb03';

// https://bscscan.com/address/0xe48a5Fd74d4A5524D76960ef3B52204C0e11fCD1
export const SVR_ETH__USD = '0xe48a5Fd74d4A5524D76960ef3B52204C0e11fCD1';

// https://bscscan.com/address/0x06159da512fBF70cb5562E79C28955cA159F0e3D
export const SVR_ETH__USD_BASE = '0x06159da512fBF70cb5562E79C28955cA159F0e3D';

// https://bscscan.com/address/0x1f771B2b1F3c3Db6C7A1d5F38961a49CEcD116dA
export const CHR__USD = '0x1f771B2b1F3c3Db6C7A1d5F38961a49CEcD116dA';

// https://bscscan.com/address/0xa400421C4be37bDfedaD2212d489b5aA7774207c
export const Real_GDP_Percent_Change_Annual_Rate = '0xa400421C4be37bDfedaD2212d489b5aA7774207c';

// https://bscscan.com/address/0x8EC213E7191488C7873cEC6daC8e97cdbAdb7B35
export const DAI__BNB = '0x8EC213E7191488C7873cEC6daC8e97cdbAdb7B35';

// https://bscscan.com/address/0xea5c2Cbb5cD57daC24E26180b19a929F3E9699B8
export const NVDA__USD = '0xea5c2Cbb5cD57daC24E26180b19a929F3E9699B8';

// https://bscscan.com/address/0xBA8683E9c3B1455bE6e18E7768e8cAD95Eb5eD49
export const DOT__BNB = '0xBA8683E9c3B1455bE6e18E7768e8cAD95Eb5eD49';

// https://bscscan.com/address/0x3E4E13C77d86d22D63c4062a70E7E89A854d5Ee4
export const SVR_USDE__USD = '0x3E4E13C77d86d22D63c4062a70E7E89A854d5Ee4';

// https://bscscan.com/address/0xA4c286Ca58280B2d54a00f77eFA6F10a38dCbA8c
export const SVR_USDE__USD_BASE = '0xA4c286Ca58280B2d54a00f77eFA6F10a38dCbA8c';

// https://bscscan.com/address/0x801A72542E6F2c1A022eC6865600D6872b191308
export const LISTA__USD = '0x801A72542E6F2c1A022eC6865600D6872b191308';

// https://bscscan.com/address/0x933458F222023B7E9f0AB2194e30d7ACcfE3603D
export const SVR_LINK__USD = '0x933458F222023B7E9f0AB2194e30d7ACcfE3603D';

// https://bscscan.com/address/0x5063761448577804901448773359da2fAF5d001e
export const SVR_LINK__USD_BASE = '0x5063761448577804901448773359da2fAF5d001e';

// https://bscscan.com/address/0xac9962aAb7b8fe63fA3A5065c22D4Dd700B1C658
export const SYRUPUSDT__USDT_Exchange_Rate = '0xac9962aAb7b8fe63fA3A5065c22D4Dd700B1C658';

// https://bscscan.com/address/0xE23e7A572099172048F06298555e5405a36592ef
export const SVR_TRX__USD = '0xE23e7A572099172048F06298555e5405a36592ef';

// https://bscscan.com/address/0xB678E64E287DB572aD35fA076cc450e8c0fA9eA9
export const SVR_TRX__USD_BASE = '0xB678E64E287DB572aD35fA076cc450e8c0fA9eA9';

// https://bscscan.com/address/0x817326922c909b16944817c207562B25C4dF16aD
export const XAG__USD = '0x817326922c909b16944817c207562B25C4dF16aD';

// https://bscscan.com/address/0xB38722F6A608646a538E882Ee9972D15c86Fc597
export const LINK__BNB = '0xB38722F6A608646a538E882Ee9972D15c86Fc597';

// https://bscscan.com/address/0xF37Be32598E9851f785acA86c2162e7C1A8466dd
export const weETH__eETH_Exchange_Rate = '0xF37Be32598E9851f785acA86c2162e7C1A8466dd';

// https://bscscan.com/address/0xEEA2ae9c074E87596A85ABE698B2Afebc9B57893
export const TSLA__USD = '0xEEA2ae9c074E87596A85ABE698B2Afebc9B57893';

// https://bscscan.com/address/0xa767f745331D267c7751297D982b050c93985627
export const ADA__USD = '0xa767f745331D267c7751297D982b050c93985627';

// https://bscscan.com/address/0x51597f405303C4377E36123cBc172b13269EA163
export const USDC__USD = '0x51597f405303C4377E36123cBc172b13269EA163';

// https://bscscan.com/address/0xdC156E0Ec3C166cdE3d4Ab9912B79e1b916E3CB7
export const sUSDX__USDX_Exchange_Rate = '0xdC156E0Ec3C166cdE3d4Ab9912B79e1b916E3CB7';

// https://bscscan.com/address/0x9e7377E194E41d63795907c92c3EB351a2eb0233
export const WIN__USD = '0x9e7377E194E41d63795907c92c3EB351a2eb0233';

// https://bscscan.com/address/0xd97aB9e5bD461eBcD55009791C410294f7B42Cdb
export const WSTETH__USD = '0xd97aB9e5bD461eBcD55009791C410294f7B42Cdb';

// https://bscscan.com/address/0xb57f259E7C24e56a1dA00F66b55A5640d9f9E7e4
export const UNI__USD = '0xb57f259E7C24e56a1dA00F66b55A5640d9f9E7e4';

// https://bscscan.com/address/0x0bf79F617988C472DcA68ff41eFe1338955b9A80
export const EUR__USD = '0x0bf79F617988C472DcA68ff41eFe1338955b9A80';

// https://bscscan.com/address/0xe96fFdE2ba50E0e869520475ee1bC73cA2dEE326
export const PFE__USD = '0xe96fFdE2ba50E0e869520475ee1bC73cA2dEE326';

// https://bscscan.com/address/0xf369A13E7f2449E58DdE8302F008eE9131f8d859
export const XVS__BNB = '0xf369A13E7f2449E58DdE8302F008eE9131f8d859';

// https://bscscan.com/address/0xaD8b4e59A7f25B68945fAf0f3a3EAF027832FFB0
export const USD1__USD = '0xaD8b4e59A7f25B68945fAf0f3a3EAF027832FFB0';

// https://bscscan.com/address/0xA59395678BB6a010a7206f46b6dab8A1e7aC7221
export const SVR_BNB__USD = '0xA59395678BB6a010a7206f46b6dab8A1e7aC7221';

// https://bscscan.com/address/0xd5D290Fe2ae6b55F385ab9C14d2CeB91DD3d9022
export const SVR_BNB__USD_BASE = '0xd5D290Fe2ae6b55F385ab9C14d2CeB91DD3d9022';

// https://bscscan.com/address/0xD5c40f5144848Bd4EF08a9605d860e727b991513
export const USDT__BNB = '0xD5c40f5144848Bd4EF08a9605d860e727b991513';

// https://bscscan.com/address/0x12bf0C3f7D5aca9E711930d704dA2774358d9210
export const KAVA__USD = '0x12bf0C3f7D5aca9E711930d704dA2774358d9210';

// https://bscscan.com/address/0xad2388190FCDc5f1d17ef5cB3106E8b781C9193d
export const CASHPlus_NAV = '0xad2388190FCDc5f1d17ef5cB3106E8b781C9193d';

// https://bscscan.com/address/0x9ef1B8c0E4F7dc8bF5719Ea496883DC6401d5b2e
export const ETH__USD = '0x9ef1B8c0E4F7dc8bF5719Ea496883DC6401d5b2e';

// https://bscscan.com/address/0x236E6f448741bc014c851D6a43456E141714A6c5
export const USDD__USDT_Exchange_Rate = '0x236E6f448741bc014c851D6a43456E141714A6c5';

// https://bscscan.com/address/0x887f177CBED2cf555a64e7bF125E1825EB69dB82
export const ONT__USD = '0x887f177CBED2cf555a64e7bF125E1825EB69dB82';

// https://bscscan.com/address/0x116EeB23384451C78ed366D4f67D5AD44eE771A0
export const BTC__BNB = '0x116EeB23384451C78ed366D4f67D5AD44eE771A0';

// https://bscscan.com/address/0x7F8caD4690A38aC28BDA3D132eF83DB1C17557Df
export const PAXG__USD = '0x7F8caD4690A38aC28BDA3D132eF83DB1C17557Df';

// https://bscscan.com/address/0x16c0C1f971b1780F952572670A9d5ce4123582a1
export const MXN__USD = '0x16c0C1f971b1780F952572670A9d5ce4123582a1';

// https://bscscan.com/address/0x2A3796273d47c4eD363b361D3AEFb7F7E2A13782
export const BETH__USD = '0x2A3796273d47c4eD363b361D3AEFb7F7E2A13782';

// https://bscscan.com/address/0xF2f8273F6b9Fc22C90891DC802cAf60eeF805cDF
export const KNC__USD = '0xF2f8273F6b9Fc22C90891DC802cAf60eeF805cDF';

// https://bscscan.com/address/0xb24D1DeE5F9a3f761D286B56d2bC44CE1D02DF7e
export const SPY__USD = '0xb24D1DeE5F9a3f761D286B56d2bC44CE1D02DF7e';

// https://bscscan.com/address/0xb056B7C804297279A9a673289264c17E6Dc6055d
export const ATOM__USD = '0xb056B7C804297279A9a673289264c17E6Dc6055d';

// https://bscscan.com/address/0x47e01580C537Cd47dA339eA3a4aFb5998CCf037C
export const SPELL__USD = '0x47e01580C537Cd47dA339eA3a4aFb5998CCf037C';

// https://bscscan.com/address/0x654C08FE9E53A8eC90d8350fB4055D4877693622
export const SVR_LTC__USD = '0x654C08FE9E53A8eC90d8350fB4055D4877693622';

// https://bscscan.com/address/0xbD4Bcf7DCFF34fd67525FceB3992cec53C23892A
export const SVR_LTC__USD_BASE = '0xbD4Bcf7DCFF34fd67525FceB3992cec53C23892A';

// https://bscscan.com/address/0x5A626d35B0eFbb23d6790774f55740557DdDf82D
export const AAVE_SVR_ETH__USD = '0x5A626d35B0eFbb23d6790774f55740557DdDf82D';

// https://bscscan.com/address/0x6E8Ce841A3234Ce137A667047d106080B56EFe6D
export const AAVE_SVR_ETH__USD_BASE = '0x6E8Ce841A3234Ce137A667047d106080B56EFe6D';

// https://bscscan.com/address/0x1672BCA4f27dE77d735381C803c39a3547F56879
export const AAVE_SVR_WSTETH__STETH_Exchange_Rate = '0x1672BCA4f27dE77d735381C803c39a3547F56879';

// https://bscscan.com/address/0x2D6Aae650054eA953CFb38CE55b6fD6c2B278B69
export const AAVE_SVR_WSTETH__STETH_Exchange_Rate_BASE =
  '0x2D6Aae650054eA953CFb38CE55b6fD6c2B278B69';

// https://bscscan.com/address/0x08CA3ac4dE41F2791e8A247859d637a8977473D7
export const SUSD1Plus_USD1_Exchange_Rate = '0x08CA3ac4dE41F2791e8A247859d637a8977473D7';

// https://bscscan.com/address/0xa679C72a97B654CFfF58aB704de3BA15Cde89B07
export const SUSHI__USD = '0xa679C72a97B654CFfF58aB704de3BA15Cde89B07';

// https://bscscan.com/address/0x264990fbd0A4796A3E3d8E37C4d5F87a3aCa5Ebf
export const BTC__USD = '0x264990fbd0A4796A3E3d8E37C4d5F87a3aCa5Ebf';

// https://bscscan.com/address/0x889158E39628C0397DC54B84F6b1cbe0AaEb7FFc
export const C98__USD = '0x889158E39628C0397DC54B84F6b1cbe0AaEb7FFc';

// https://bscscan.com/address/0x21042b1b70602ae936E74d34F012aafE578dAf04
export const JAAA_NAV = '0x21042b1b70602ae936E74d34F012aafE578dAf04';

// https://bscscan.com/address/0x68ff0d4499c68Cf4471143930422ae8F17f6Cd58
export const xSolvBTC_NAV = '0x68ff0d4499c68Cf4471143930422ae8F17f6Cd58';

// https://bscscan.com/address/0x7E728dFA6bCa9023d9aBeE759fDF56BEAb8aC7aD
export const TWT__BNB = '0x7E728dFA6bCa9023d9aBeE759fDF56BEAb8aC7aD';

// https://bscscan.com/address/0xA615Be6cb0f3F36A641858dB6F30B9242d0ABeD8
export const SHIB__USD = '0xA615Be6cb0f3F36A641858dB6F30B9242d0ABeD8';

// https://bscscan.com/address/0xD164a1559e78B9e6eacb12B2E627F31d2f603C0f
export const ezETH__ETH = '0xD164a1559e78B9e6eacb12B2E627F31d2f603C0f';

// https://bscscan.com/address/0x1A083354421Da4e26D78D55DAfaeBf4CFc541dAf
export const SVR_TWT__BNB = '0x1A083354421Da4e26D78D55DAfaeBf4CFc541dAf';

// https://bscscan.com/address/0x6C28277b9a482F514964642C8E80EAb25D9B16e8
export const SVR_TWT__BNB_BASE = '0x6C28277b9a482F514964642C8E80EAb25D9B16e8';

// https://bscscan.com/address/0x337B4889fed5557595c37a45c1BB9b057cC670AE
export const YETH_ETH_Exchange_Rate = '0x337B4889fed5557595c37a45c1BB9b057cC670AE';

// https://bscscan.com/address/0x1CcaD765D39Aa2060eB4f6dD94e5874db786C16f
export const PHP__USD = '0x1CcaD765D39Aa2060eB4f6dD94e5874db786C16f';

// https://bscscan.com/address/0x0E8a53DD9c13589df6382F13dA6B3Ec8F919B323
export const SOL__USD = '0x0E8a53DD9c13589df6382F13dA6B3Ec8F919B323';

// https://bscscan.com/address/0xB6064eD41d4f67e353768aA239cA86f4F73665a1
export const CAKE__USD = '0xB6064eD41d4f67e353768aA239cA86f4F73665a1';

// https://bscscan.com/address/0xe3cA2f3Bad1D8327820f648C759f17162b5383ae
export const CFX__USD = '0xe3cA2f3Bad1D8327820f648C759f17162b5383ae';

// https://bscscan.com/address/0x06F34EdD61Be3b2Ff3F630B500dF81eeA8312350
export const ezETH__ETH_Exchange_Rate = '0x06F34EdD61Be3b2Ff3F630B500dF81eeA8312350';

// https://bscscan.com/address/0x1Fa0D75D5b90d230da2A610F2B1B2Eaf9a44Dd5f
export const SVR_AAVE__USD = '0x1Fa0D75D5b90d230da2A610F2B1B2Eaf9a44Dd5f';

// https://bscscan.com/address/0x5B059cFFFfa80f882A4619d25A118F490D3031F9
export const SVR_AAVE__USD_BASE = '0x5B059cFFFfa80f882A4619d25A118F490D3031F9';

// https://bscscan.com/address/0x63A9133cd7c611d6049761038C16f238FddA71d7
export const INJ__USD = '0x63A9133cd7c611d6049761038C16f238FddA71d7';

// https://bscscan.com/address/0x9889f7726F0235c8e975BcD9F2256FdF90AfE515
export const AAVE_SVR_BTC__USD = '0x9889f7726F0235c8e975BcD9F2256FdF90AfE515';

// https://bscscan.com/address/0xE0AA38B3655267a05465F2CBD668c924dEC60271
export const AAVE_SVR_BTC__USD_BASE = '0xE0AA38B3655267a05465F2CBD668c924dEC60271';

// https://bscscan.com/address/0xea93C82fa07773ed645d8A79eE27041eb867f221
export const slisBNB__BNB_Exchange_Rate = '0xea93C82fa07773ed645d8A79eE27041eb867f221';

// https://bscscan.com/address/0x14248836ac6aB5e71D1320C083C6905e8ed08A43
export const PCE_Price_Index_Percent_Change_Annual_Rate =
  '0x14248836ac6aB5e71D1320C083C6905e8ed08A43';

// https://bscscan.com/address/0x3b37C6f1e3207DE5a4664E837072Bd9A25269B39
export const Calculated_SAVAX__USD = '0x3b37C6f1e3207DE5a4664E837072Bd9A25269B39';

// https://bscscan.com/address/0x8FAf16F710003E538189334541F5D4a391Da46a0
export const GBP__USD = '0x8FAf16F710003E538189334541F5D4a391Da46a0';

// https://bscscan.com/address/0x63D407F32Aa72E63C7209ce1c2F5dA40b3AaE726
export const ETH__BNB = '0x63D407F32Aa72E63C7209ce1c2F5dA40b3AaE726';

// https://bscscan.com/address/0x081195B56674bb87b2B92F6D58F7c5f449aCE19d
export const POL__USD = '0x081195B56674bb87b2B92F6D58F7c5f449aCE19d';

// https://bscscan.com/address/0x87701B15C08687341c2a847ca44eCfBc8d7873E1
export const DODO__USD = '0x87701B15C08687341c2a847ca44eCfBc8d7873E1';

// https://bscscan.com/address/0xf1769eB4D1943AF02ab1096D7893759F6177D6B8
export const BTC__ETH = '0xf1769eB4D1943AF02ab1096D7893759F6177D6B8';

// https://bscscan.com/address/0xcBb98864Ef56E9042e7d2efef76141f15731B82f
export const BUSD__USD = '0xcBb98864Ef56E9042e7d2efef76141f15731B82f';

// https://bscscan.com/address/0xB82310F6aE632C8c7016D3DbF2a997CA5039292A
export const SVR_DAI__USD = '0xB82310F6aE632C8c7016D3DbF2a997CA5039292A';

// https://bscscan.com/address/0x2aD32213F242f34DbB6e1331CAB21174040060F0
export const SVR_DAI__USD_BASE = '0x2aD32213F242f34DbB6e1331CAB21174040060F0';

// https://bscscan.com/address/0x00EdEa5d03E6Cb155662dBF1B00dea5693Be874A
export const THB__USD = '0x00EdEa5d03E6Cb155662dBF1B00dea5693Be874A';

// https://bscscan.com/address/0x131AC00f2CFa72dc06fEdE8C594B3E842D0E864a
export const SVR_ADA__USD = '0x131AC00f2CFa72dc06fEdE8C594B3E842D0E864a';

// https://bscscan.com/address/0x7cC357e6d5517b01195Bb341384840BE1685E396
export const SVR_ADA__USD_BASE = '0x7cC357e6d5517b01195Bb341384840BE1685E396';

// https://bscscan.com/address/0x8264d6983B219be65C4D62f1c82B3A2999944cF2
export const XTZ__BNB = '0x8264d6983B219be65C4D62f1c82B3A2999944cF2';

// https://bscscan.com/address/0xE188A9875af525d25334d75F3327863B2b8cd0F1
export const SXP__USD = '0xE188A9875af525d25334d75F3327863B2b8cd0F1';

// https://bscscan.com/address/0x02Bfe714e78E2Ad1bb1C2beE93eC8dc5423B66d4
export const WOO__USD = '0x02Bfe714e78E2Ad1bb1C2beE93eC8dc5423B66d4';

// https://bscscan.com/address/0x7754aE2B053c9C8CEF3dAE027f3376675E85A301
export const PCE_Price_Index_Level = '0x7754aE2B053c9C8CEF3dAE027f3376675E85A301';

// https://bscscan.com/address/0xA40a0dC23D3A821fF5Ea9E23080B74DAC031158d
export const WSTUSR_STUSR_Exchange_Rate = '0xA40a0dC23D3A821fF5Ea9E23080B74DAC031158d';

// https://bscscan.com/address/0x6b25F7f189c3f26d3caC43b754578b67Fc8d952A
export const MS__USD = '0x6b25F7f189c3f26d3caC43b754578b67Fc8d952A';

// https://bscscan.com/address/0xdC7eA2fa4068d135D7A7a9f3583f674c34eF114a
export const sUSDf__USDf_Exchange_Rate = '0xdC7eA2fa4068d135D7A7a9f3583f674c34eF114a';

// https://bscscan.com/address/0xE8ed18E29402CD223bC5B73D30e40CCdf7b72986
export const USR__USD = '0xE8ed18E29402CD223bC5B73D30e40CCdf7b72986';

// https://bscscan.com/address/0x93A67D414896A280bF8FFB3b389fE3686E014fda
export const XRP__USD = '0x93A67D414896A280bF8FFB3b389fE3686E014fda';

// https://bscscan.com/address/0xca236E327F629f9Fc2c30A4E95775EbF0B89fac8
export const LINK__USD = '0xca236E327F629f9Fc2c30A4E95775EbF0B89fac8';

// https://bscscan.com/address/0xA8357BF572460fC40f4B0aCacbB2a6A61c89f475
export const AAVE__USD = '0xA8357BF572460fC40f4B0aCacbB2a6A61c89f475';

// https://bscscan.com/address/0x498F912B09B5dF618c77fcC9E8DA503304Df92bF
export const AUD__USD = '0x498F912B09B5dF618c77fcC9E8DA503304Df92bF';

// https://bscscan.com/address/0x8fCC2d2973e3740c40aF00d030725A429cd24b57
export const TREE__USD = '0x8fCC2d2973e3740c40aF00d030725A429cd24b57';

// https://bscscan.com/address/0xbA1b481dba75DA598fcD56668C241c86CfccAA72
export const SVR_TUSD__USD = '0xbA1b481dba75DA598fcD56668C241c86CfccAA72';

// https://bscscan.com/address/0x6A241485a4CB366B23e2e22F0CbcE36D44Df7877
export const SVR_TUSD__USD_BASE = '0x6A241485a4CB366B23e2e22F0CbcE36D44Df7877';

// https://bscscan.com/address/0x058316f8Bb13aCD442ee7A216C7b60CFB4Ea1B53
export const VAI__USD = '0x058316f8Bb13aCD442ee7A216C7b60CFB4Ea1B53';

// https://bscscan.com/address/0x81ca991cEf14e7bFB3fa8cc70303a2DEaEb09A42
export const Solv_Proof_of_Reserves = '0x81ca991cEf14e7bFB3fa8cc70303a2DEaEb09A42';

// https://bscscan.com/address/0x31d1b9c8aEAE40deb49320030d1253060d2410BE
export const SVR_SUSDE__USDE_Exchange_Rate = '0x31d1b9c8aEAE40deb49320030d1253060d2410BE';

// https://bscscan.com/address/0x39BeCD409EE4283C1E04c61764825Bb465D45c7F
export const SVR_SUSDE__USDE_Exchange_Rate_BASE = '0x39BeCD409EE4283C1E04c61764825Bb465D45c7F';

// https://bscscan.com/address/0x657e700c66C48c135c4A29c4292908DbdA7aa280
export const FET__USD = '0x657e700c66C48c135c4A29c4292908DbdA7aa280';

// https://bscscan.com/address/0x4e3464353E99E7cFB0E53918222411C08ae3606a
export const SVR_CAKE__USD = '0x4e3464353E99E7cFB0E53918222411C08ae3606a';

// https://bscscan.com/address/0x96125CCbE22291dFe02bFAF80b8f74d9f9c3E60A
export const SVR_CAKE__USD_BASE = '0x96125CCbE22291dFe02bFAF80b8f74d9f9c3E60A';

// https://bscscan.com/address/0x3f5fc2cb37dA3B351F7EF968d72bE2eC3e1da08e
export const LISUSD__USD = '0x3f5fc2cb37dA3B351F7EF968d72bE2eC3e1da08e';

// https://bscscan.com/address/0x9f1fD2cEf7b226D555A747DA0411F93c5fe74e13
export const VET__USD = '0x9f1fD2cEf7b226D555A747DA0411F93c5fe74e13';

// https://bscscan.com/address/0x964261740356cB4aaD0C3D2003Ce808A4176a46d
export const CHF__USD = '0x964261740356cB4aaD0C3D2003Ce808A4176a46d';

// https://bscscan.com/address/0x4214a460F33767e9b5516B694f9948cdeF3EE927
export const SVR_FDUSD__USD = '0x4214a460F33767e9b5516B694f9948cdeF3EE927';

// https://bscscan.com/address/0x3bB95dEA358F6790978931D1b6BE6f803Acc2AeD
export const SVR_FDUSD__USD_BASE = '0x3bB95dEA358F6790978931D1b6BE6f803Acc2AeD';

// https://bscscan.com/address/0xb631F3Cb6B3a5EebF72C97e30c377de061C6a87c
export const SVR_USDT__USD = '0xb631F3Cb6B3a5EebF72C97e30c377de061C6a87c';

// https://bscscan.com/address/0x501e21126486424567f40D490856094D72986E41
export const SVR_USDT__USD_BASE = '0x501e21126486424567f40D490856094D72986E41';

// https://bscscan.com/address/0x19995C3f82Ea476ae6c635BBbcb81c43030089eb
export const WSRUSD_RUSD_Exchange_Rate = '0x19995C3f82Ea476ae6c635BBbcb81c43030089eb';

// https://bscscan.com/address/0xDE1952A1bF53f8E558cc761ad2564884E55B2c6F
export const ZAR__USD = '0xDE1952A1bF53f8E558cc761ad2564884E55B2c6F';

// https://bscscan.com/address/0xcabb46FfB38c93348Df16558DF156e9f68F9F7F1
export const AAVE_Network_Emergency_Count_BNB_Chain = '0xcabb46FfB38c93348Df16558DF156e9f68F9F7F1';

// https://bscscan.com/address/0x66cD2975d02f5F5cdEF2E05cBca12549B1a5022D
export const GME__USD = '0x66cD2975d02f5F5cdEF2E05cBca12549B1a5022D';

// https://bscscan.com/address/0x2d5Fc41d1365fFe13d03d91E82e04Ca878D69f4B
export const ADA__BNB = '0x2d5Fc41d1365fFe13d03d91E82e04Ca878D69f4B';

// https://bscscan.com/address/0x2Ab73dc1C8A23bcDDb4850Ff811850E0d2a0c72f
export const U__USD = '0x2Ab73dc1C8A23bcDDb4850Ff811850E0d2a0c72f';

// https://bscscan.com/address/0xa3334A9762090E827413A7495AfeCE76F41dFc06
export const TUSD__USD = '0xa3334A9762090E827413A7495AfeCE76F41dFc06';

// https://bscscan.com/address/0x0E9D55932893Fb1308882C7857285B2B0bcc4f4a
export const FXS__USD = '0x0E9D55932893Fb1308882C7857285B2B0bcc4f4a';

// https://bscscan.com/address/0x4c75d01cfa4D998770b399246400a6dc40FB9645
export const wstETH__stETH_Exchange_Rate = '0x4c75d01cfa4D998770b399246400a6dc40FB9645';

// https://bscscan.com/address/0x601CaA447C59Dc4E25992f4057BbE828F66193C0
export const SolvBTCBBN__SolvBTC_Exchange_Rate = '0x601CaA447C59Dc4E25992f4057BbE828F66193C0';

// https://bscscan.com/address/0x2577638066F86C235E2c93bcdE24D5BC849f337E
export const USDu_Reserves = '0x2577638066F86C235E2c93bcdE24D5BC849f337E';

// https://bscscan.com/address/0x798A65D349B2B5E6645695912880b54dfFd79074
export const XRP__BNB = '0x798A65D349B2B5E6645695912880b54dfFd79074';

// https://bscscan.com/address/0x7bDAEb1399c37D0Ff6891F6E6B4A425989e1a105
export const Real_Final_Sales_to_Private_Domestic_Purchasers_Level =
  '0x7bDAEb1399c37D0Ff6891F6E6B4A425989e1a105';

// https://bscscan.com/address/0x390180e80058A8499930F0c13963AD3E0d86Bfc9
export const FDUSD__USD = '0x390180e80058A8499930F0c13963AD3E0d86Bfc9';

// https://bscscan.com/address/0x4978c0abE6899178c1A74838Ee0062280888E2Cf
export const MASK__USD = '0x4978c0abE6899178c1A74838Ee0062280888E2Cf';

// https://bscscan.com/address/0xBF63F430A79D4036A5900C19818aFf1fa710f206
export const XVS__USD = '0xBF63F430A79D4036A5900C19818aFf1fa710f206';

// https://bscscan.com/address/0xcF95796f3016801A1dA5C518Fc7A59C51dcEf793
export const ONG__USD = '0xcF95796f3016801A1dA5C518Fc7A59C51dcEf793';

// https://bscscan.com/address/0x84210d9013A30C6ab169e28840A6CC54B60fa042
export const ICP__USD = '0x84210d9013A30C6ab169e28840A6CC54B60fa042';

// https://bscscan.com/address/0x71cdD4BD7C42C752325cC7208deC1b3B418F1706
export const SVR_xSolvBTC__SolvBTC_Exchange_Rate = '0x71cdD4BD7C42C752325cC7208deC1b3B418F1706';

// https://bscscan.com/address/0x3d0eB83D2c7c944c0278A5240E520C1F472D7577
export const SVR_xSolvBTC__SolvBTC_Exchange_Rate_BASE =
  '0x3d0eB83D2c7c944c0278A5240E520C1F472D7577';

// https://bscscan.com/address/0x696B7eA5827548cd35C743A0a05c1f3130196e5e
export const stBTC_Proof_of_Reserves = '0x696B7eA5827548cd35C743A0a05c1f3130196e5e';

// https://bscscan.com/address/0x10402B01cD2E6A9ed6DBe683CbC68f78Ff02f8FC
export const USDE__USD = '0x10402B01cD2E6A9ed6DBe683CbC68f78Ff02f8FC';

// https://bscscan.com/address/0x8f26ba94180371baA2D2C143f96b6886DCACA250
export const JPM__USD = '0x8f26ba94180371baA2D2C143f96b6886DCACA250';

// https://bscscan.com/address/0x3ae518be05e3F7faBf7e3Ace22Af795D7A09c2E5
export const ASTER__USD = '0x3ae518be05e3F7faBf7e3Ace22Af795D7A09c2E5';

// https://bscscan.com/address/0xB5543DA4D87D13b736c31b9C2c21F95667E20dF7
export const SVR_XRP__USD = '0xB5543DA4D87D13b736c31b9C2c21F95667E20dF7';

// https://bscscan.com/address/0x3c5E1a4E6ABe23D8D56C7903e91e11af845b6432
export const SVR_XRP__USD_BASE = '0x3c5E1a4E6ABe23D8D56C7903e91e11af845b6432';

// https://bscscan.com/address/0x26d77e724AE4394d7719a2CbF56008f0B3Ae6886
export const SVR_FIL__USD = '0x26d77e724AE4394d7719a2CbF56008f0B3Ae6886';

// https://bscscan.com/address/0x448868F78f0Bab080fd31BdE838225d472378dbE
export const SVR_FIL__USD_BASE = '0x448868F78f0Bab080fd31BdE838225d472378dbE';

// https://bscscan.com/address/0xD3F669EF5C364C14d353F46b1D1a048A846e00f1
export const WLFI__USD = '0xD3F669EF5C364C14d353F46b1D1a048A846e00f1';

// https://bscscan.com/address/0xE9736eB458b0741e781E460228b9e5291488F7cE
export const MUSD__USD = '0xE9736eB458b0741e781E460228b9e5291488F7cE';

// https://bscscan.com/address/0x20123C6ebd45c6496102BeEA86e1a6616Ca547c6
export const RDNT__USD = '0x20123C6ebd45c6496102BeEA86e1a6616Ca547c6';

// https://bscscan.com/address/0xeDA73F8acb669274B15A977Cb0cdA57a84F18c2a
export const GOOGL__USD = '0xeDA73F8acb669274B15A977Cb0cdA57a84F18c2a';

// https://bscscan.com/address/0xb1BED6C1fC1adE2A975F54F24851c7F410e27718
export const WTI__USD = '0xb1BED6C1fC1adE2A975F54F24851c7F410e27718';

// https://bscscan.com/address/0xdF4Dd957a84F798acFADd448badd2D8b9bC99047
export const HIGH__USD = '0xdF4Dd957a84F798acFADd448badd2D8b9bC99047';

// https://bscscan.com/address/0xfD5D618c3Ee64c6716876B02e26690811DF86508
export const JTRSY_NAV = '0xfD5D618c3Ee64c6716876B02e26690811DF86508';

// https://bscscan.com/address/0x2a548935a323Bb7329a5E3F1667B979f16Bc890b
export const BCH__BNB = '0x2a548935a323Bb7329a5E3F1667B979f16Bc890b';

// https://bscscan.com/address/0x7CA57b0cA6367191c94C8914d7Df09A57655905f
export const MATIC__USD = '0x7CA57b0cA6367191c94C8914d7Df09A57655905f';

// https://bscscan.com/address/0x08E70777b982a58D23D05E3D7714f44837c06A21
export const BSW__USD = '0x08E70777b982a58D23D05E3D7714f44837c06A21';

// https://bscscan.com/address/0xB21e42B29a1e0beA17635C92e6A98A08112E19F8
export const sUSDD__USDD_Exchange_Rate = '0xB21e42B29a1e0beA17635C92e6A98A08112E19F8';

// https://bscscan.com/address/0x0567F2323251f0Aab15c8dFb1967E4e8A7D42aeE
export const BNB__USD = '0x0567F2323251f0Aab15c8dFb1967E4e8A7D42aeE';

// https://bscscan.com/address/0x51d08ca89d3e8c12535BA8AEd33cDf2557ab5b2a
export const AMZN__USD = '0x51d08ca89d3e8c12535BA8AEd33cDf2557ab5b2a';

// https://bscscan.com/address/0xc4429B539397a3166eF3ef132c29e34715a3ABb4
export const Calculated_BNBx__USD = '0xc4429B539397a3166eF3ef132c29e34715a3ABb4';

// https://bscscan.com/address/0x5974855ce31EE8E1fff2e76591CbF83D7110F151
export const AVAX__USD = '0x5974855ce31EE8E1fff2e76591CbF83D7110F151';

// https://bscscan.com/address/0xb7Ed5bE7977d61E83534230f3256C021e0fae0B6
export const AAPL__USD = '0xb7Ed5bE7977d61E83534230f3256C021e0fae0B6';

// https://bscscan.com/address/0x13A9c98b07F098c5319f4FF786eB16E22DC738e1
export const FRAX__USD = '0x13A9c98b07F098c5319f4FF786eB16E22DC738e1';

// https://bscscan.com/address/0x0Db8945f9aEf5651fa5bd52314C5aAe78DfDe540
export const COMP__USD = '0x0Db8945f9aEf5651fa5bd52314C5aAe78DfDe540';

// https://bscscan.com/address/0x59CD46F53D66F51B2F58d134fB9c279b73668D60
export const AAVE_SVR_BNB__USD = '0x59CD46F53D66F51B2F58d134fB9c279b73668D60';

// https://bscscan.com/address/0x8fd3E788A8cF55C62B5A731ADa7ad8B1d2BFf851
export const AAVE_SVR_BNB__USD_BASE = '0x8fd3E788A8cF55C62B5A731ADa7ad8B1d2BFf851';

// https://bscscan.com/address/0xC6A1314E89d01517a90AE4b0d9d5e499A324B283
export const STONE__ETH_Exchange_Rate = '0xC6A1314E89d01517a90AE4b0d9d5e499A324B283';

// https://bscscan.com/address/0x45f86CA2A8BC9EBD757225B19a1A0D7051bE46Db
export const USDC__BNB = '0x45f86CA2A8BC9EBD757225B19a1A0D7051bE46Db';

// https://bscscan.com/address/0x9A18137ADCF7b05f033ad26968Ed5a9cf0Bf8E6b
export const XTZ__USD = '0x9A18137ADCF7b05f033ad26968Ed5a9cf0Bf8E6b';

// https://bscscan.com/address/0x8b0D36ae4CF8e277773A7ba5F35c09Edb144241b
export const GMT__USD = '0x8b0D36ae4CF8e277773A7ba5F35c09Edb144241b';

// https://bscscan.com/address/0x0Fe4D87883005fCAFaF56B81d09473D9A29dCDC3
export const NEAR__USD = '0x0Fe4D87883005fCAFaF56B81d09473D9A29dCDC3';

// https://bscscan.com/address/0x5D209cE1fBABeAA8E6f9De4514A74FFB4b34560F
export const MSFT__USD = '0x5D209cE1fBABeAA8E6f9De4514A74FFB4b34560F';

// https://bscscan.com/address/0xB97Ad0E74fa7d920791E90258A6E2085088b4320
export const USDT__USD = '0xB97Ad0E74fa7d920791E90258A6E2085088b4320';

// https://bscscan.com/address/0x472750d4112edBf65162F43B1c8F8e92486b6798
export const SVR_BCH__USD = '0x472750d4112edBf65162F43B1c8F8e92486b6798';

// https://bscscan.com/address/0x222A1317cF61ABfA7A8b07DD2539672addEC5C2b
export const SVR_BCH__USD_BASE = '0x222A1317cF61ABfA7A8b07DD2539672addEC5C2b';

// https://bscscan.com/address/0xfc76E9445952A3C31369dFd26edfdfb9713DF5Bb
export const META__USD = '0xfc76E9445952A3C31369dFd26edfdfb9713DF5Bb';

// https://bscscan.com/address/0x454d5D79D979D91FE3204b648E1E3Da8C1157A25
export const USDD__USDC_Exchange_Rate = '0x454d5D79D979D91FE3204b648E1E3Da8C1157A25';

// https://bscscan.com/address/0xcB23da9EA243f53194CBc2380A6d4d9bC046161f
export const CAKE__BNB = '0xcB23da9EA243f53194CBc2380A6d4d9bC046161f';

// https://bscscan.com/address/0xEe7Fb910B9C5e80A40106C8f00aD26dE1C94A0c8
export const SVR_USD1__USD = '0xEe7Fb910B9C5e80A40106C8f00aD26dE1C94A0c8';

// https://bscscan.com/address/0x2A89B6962b4Fb66243F9797F1F2d8d2aE1673Ef4
export const SVR_USD1__USD_BASE = '0x2A89B6962b4Fb66243F9797F1F2d8d2aE1673Ef4';

// https://bscscan.com/address/0x132d3C0B1D2cEa0BC552588063bdBb210FDeecfA
export const DAI__USD = '0x132d3C0B1D2cEa0BC552588063bdBb210FDeecfA';

// https://bscscan.com/address/0x1fE6c9Bd9B29e5810c2819f37dDa8559739ebeC9
export const NFLX__USD = '0x1fE6c9Bd9B29e5810c2819f37dDa8559739ebeC9';

// https://bscscan.com/address/0x3065b2369820f76C829b9BBCAF4B90F9f47d6314
export const SGD__USD = '0x3065b2369820f76C829b9BBCAF4B90F9f47d6314';

// https://bscscan.com/address/0x43d80f616DAf0b0B42a928EeD32147dC59027D41
export const BCH__USD = '0x43d80f616DAf0b0B42a928EeD32147dC59027D41';

// https://bscscan.com/address/0x70dFc219Fb289A20EC3431548b30dbE2c653AA9B
export const AAVE_SVR_USDT__USD = '0x70dFc219Fb289A20EC3431548b30dbE2c653AA9B';

// https://bscscan.com/address/0x4C45cf184D62E5a225101F06E24255a62CF2b28F
export const AAVE_SVR_USDT__USD_BASE = '0x4C45cf184D62E5a225101F06E24255a62CF2b28F';

// https://bscscan.com/address/0x7a6B6F81BeDBE9C25893455c985f356E2853C283
export const AAVE_SVR_USDC__USD = '0x7a6B6F81BeDBE9C25893455c985f356E2853C283';

// https://bscscan.com/address/0x7c15aB340495a4D232553E1ebF78A9e6da66e834
export const AAVE_SVR_USDC__USD_BASE = '0x7c15aB340495a4D232553E1ebF78A9e6da66e834';

// https://bscscan.com/address/0xF841761481DF19831cCC851A54D8350aE6022583
export const YFI__BNB = '0xF841761481DF19831cCC851A54D8350aE6022583';

// https://bscscan.com/address/0x6101F4DFBb24Cac3D64e28A815255B428b93639f
export const MRNA__USD = '0x6101F4DFBb24Cac3D64e28A815255B428b93639f';

// https://bscscan.com/address/0x266d063Bb9BD7f1CEA6F77573D01d0F9cEbBAB62
export const Real_Final_Sales_to_Private_Domestic_Purchasers_Percent_Change_Annual_Rate =
  '0x266d063Bb9BD7f1CEA6F77573D01d0F9cEbBAB62';

// https://bscscan.com/address/0x4641327e9aD5df9568AF01363D9E7aEdDDEb33e9
export const SVR_USDC__USD = '0x4641327e9aD5df9568AF01363D9E7aEdDDEb33e9';

// https://bscscan.com/address/0x8068600c8f6d2fB3d44F5B4cb7E7f4Ac47c2c742
export const SVR_USDC__USD_BASE = '0x8068600c8f6d2fB3d44F5B4cb7E7f4Ac47c2c742';

// https://bscscan.com/address/0x27Cc356A5891A3Fe6f84D0457dE4d108C6078888
export const XLM__USD = '0x27Cc356A5891A3Fe6f84D0457dE4d108C6078888';

// https://bscscan.com/address/0x9A41B56b2c24683E2f23BdE15c14BC7c4a58c3c4
export const QQQ__USD = '0x9A41B56b2c24683E2f23BdE15c14BC7c4a58c3c4';

// https://bscscan.com/address/0x0776362fF16beA8858e4F6bCA8d351941B75EbA1
export const YBTC_BTC_Exchange_Rate = '0x0776362fF16beA8858e4F6bCA8d351941B75EbA1';

// https://bscscan.com/address/0xCA9112fC543C662F857A5f949585Fe054933cD72
export const SAVUSD__AVUSD_Exchange_Rate = '0xCA9112fC543C662F857A5f949585Fe054933cD72';

// https://bscscan.com/address/0x86896fEB19D8A607c3b11f2aF50A0f239Bd71CD0
export const XAU__USD = '0x86896fEB19D8A607c3b11f2aF50A0f239Bd71CD0';

// https://bscscan.com/address/0x3400969D9b6156d75EC16c81296b93b3149B0E7C
export const Real_GDP_Level = '0x3400969D9b6156d75EC16c81296b93b3149B0E7C';

// https://bscscan.com/address/0x5cb1Cb3eA5FB46de1CE1D0F3BaDB3212e8d8eF48
export const BRL__USD = '0x5cb1Cb3eA5FB46de1CE1D0F3BaDB3212e8d8eF48';

// https://bscscan.com/address/0x74E72F37A8c415c8f1a98Ed42E78Ff997435791D
export const LTC__USD = '0x74E72F37A8c415c8f1a98Ed42E78Ff997435791D';

export const CHAIN_ID = 56;
